import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Document } from '../../models/document.model';

@Component({
  selector: 'app-documents-viewer',
  templateUrl: './documents-viewer.component.html',
  styleUrls: ['./documents-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsViewerComponent {
  @Input() public documents?: Document[];
}
